import React, { PropsWithChildren, useRef, useState } from 'react';
import styled from 'styled-components';
import { HamburgerMenuIcon } from '../../../assets';
import { breakpoint, theme } from '../../../theme';
import { useBreakpointMap } from '../../../utils';
import { UIText } from '../../typography';
import { CategoryList } from './CategoryList';
import { CategoryListItem } from './types';

const Container = styled.div`
  display: flex;
  flex-shrink: 0;
  ${breakpoint('md')`
    width: 264px;
    position: relative;
  `};
`;

const CategoryButton = styled.button`
  display: flex;
  gap: ${theme.spacings[2].rem};
  width: 100%;
  background-color: ${theme.colors.primary.white};
  padding-left: 0;
  padding-right: ${theme.spacings[6].rem};
  box-sizing: border-box;
  border: none;
  align-items: center;
  cursor: pointer;
  ${breakpoint('md')`
    background-color: ${theme.colors.tints.graysRed['_2']};
    padding-left: ${theme.spacings[4].rem};
    height: 72px;
  `}
`;

const HideOnMobile = styled.span`
  display: none;
  ${breakpoint('md')`
    display: inline-block;
  `}
`;

const NavigationUIText = styled(UIText).attrs({ size: 'lg' })`
  color: ${theme.colors.primary.white};
`;

export type CategoryNavigationProps = {
  categories: CategoryListItem[];
  linkComponent?: React.FunctionComponent<PropsWithChildren<{ href: string }>>;
};

export const CategoryNavigation: React.FC<CategoryNavigationProps> = ({
  categories,
  linkComponent,
}) => {
  const ref = useRef<HTMLButtonElement>(null);
  const [isOpen, setIsOpen] = useState(false);
  const viewportSize = useBreakpointMap({
    xs: 'Responsive',
    sm: 'tablet',
    md: 'Desktop',
  });
  const isMobile = viewportSize !== undefined && viewportSize !== 'Desktop';
  let fillColor = theme.colors.primary.white;
  let iconWidth = 18;
  if (isMobile) {
    fillColor = theme.colors.primary.black;
    iconWidth = 22;
  }
  return (
    <Container>
      <CategoryButton ref={ref} onClick={() => setIsOpen(!isOpen)}>
        <HamburgerMenuIcon fill={fillColor} width={iconWidth} />
        <HideOnMobile>
          {!isMobile && <NavigationUIText>All Categories</NavigationUIText>}
        </HideOnMobile>
      </CategoryButton>

      <CategoryList
        categories={categories}
        linkComponent={linkComponent}
        isOpen={isOpen}
        onClose={(e) => {
          if (ref.current && ref.current.contains(e?.target as Node)) return;
          setIsOpen(false);
        }}
      />
    </Container>
  );
};
